import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import LogoHeader from '../login/includes/LogoHeader'
import AppRoutes from '../../routes/appRoutes'
import useRequest from '../../hooks/useRequest'

const Maintenance = props => {
    const {
        history,
        setIsInMaintenanceMode,
        onCheckMaintenanceMode,
        maintenanceModeMessage,
        maintenanceModeLink,
        getMaintenanceModeLink,
    } = props
    let intervalID = 0

    const { changeNeedsUpdate } = useRequest()

    const onRedirectToHome = () => {
        setIsInMaintenanceMode(false)
        clearInterval(intervalID)
        Promise.resolve(
            changeNeedsUpdate({ dashboard: true, request: true }),
        ).then(() => {
            history.push(AppRoutes.dashboard())
        })
    }

    useEffect(() => {
        // Fetch link once when component mounts
        if (getMaintenanceModeLink) {
            getMaintenanceModeLink()
        }

        intervalID = setInterval(
            () => onCheckMaintenanceMode(onRedirectToHome),
            600000, // 10 minutes
        )

        return () => {
            clearInterval(intervalID)
        }
    }, [])

    return (
        <div className="bg-maintenanceBackground h-screen flex flex-col overflow-hidden">
            {/* LogoHeader -- Includes */}
            <LogoHeader />

            <div className="w-full flex-grow flex flex-col items-center justify-between">
                <div className="text-center shrink-0">
                    <h1 className="text-4xl font-bold mb-4 text-yellow">
                        Maintenance Mode
                    </h1>
                    <p className="text-2xl font-medium max-w-2xl ">
                        {maintenanceModeMessage}
                    </p>
                    {maintenanceModeLink && maintenanceModeLink.hasLink && (
                        <p className="text-2xl font-medium max-w-2xl mt-4">
                            <a
                                href={maintenanceModeLink.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-yellow hover:underline"
                            >
                                {maintenanceModeLink.linkText}
                            </a>
                        </p>
                    )}
                </div>

                <div
                    className="flex justify-center w-full flex-1 mt-8"
                    style={{ textAlign: 'center' }}
                >
                    <img
                        className="max-h-70%"
                        src="/images/maintenance_mode-crop.gif"
                        alt="The application is currently in maintenance mode. Please try again later."
                        title="The application is currently in maintenance mode. Please try again later."
                    />
                </div>
            </div>
        </div>
    )
}

Maintenance.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }),
    setIsInMaintenanceMode: PropTypes.func,
    onCheckMaintenanceMode: PropTypes.func,
    maintenanceModeMessage: PropTypes.string,
    maintenanceModeLink: PropTypes.shape({
        link: PropTypes.string,
        linkText: PropTypes.string,
        hasLink: PropTypes.bool,
    }),
    getMaintenanceModeLink: PropTypes.func,
}

export default Maintenance
